import { render, staticRenderFns } from "./item_favorite.vue?vue&type=template&id=efd6a602&scoped=true&"
import script from "./item_favorite.vue?vue&type=script&lang=js&"
export * from "./item_favorite.vue?vue&type=script&lang=js&"
import style0 from "./item_favorite.vue?vue&type=style&index=0&id=efd6a602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd6a602",
  null
  
)

export default component.exports